import { Plus } from "lucide-react";

import { VaccineModal } from "components/Modal/VaccineModal";
import { Button } from "components/ui/Button";
import { ConfirmDialog } from "components/ui/ConfirmDialog";
import { DataTable } from "components/ui/DataTable";
import { PageHeader } from "components/ui/PageHeader";
import { TabSwitcher } from "components/ui/TabSwitcher";
import { vaccineCodesColumns, vaccinesColumns } from "features/vaccineSettings/columns";
import { useVaccinesPage } from "features/vaccineSettings/hooks/useVaccinesPage";
import { TAB_OPTIONS } from "features/vaccineSettings/utils";

import styles from "./VaccinesPage.module.css";

export const VaccinesPage = () => {
  const {
    activeTab,
    setActiveTab,
    showModal,
    setShowModal,
    selectedVaccine,
    confirmDialog,
    closeConfirmDialog,
    vaccines,
    isLoadingVaccines,
    systemFilters,
    vaccineCodes,
    isLoadingCodes,
    healthlinkFilters,
    isDeleting,
    isToggling,
    rowActions,
    handleAddVaccine,
    handleSaveVaccine,
  } = useVaccinesPage();

  return (
    <div className={styles.content}>
      <PageHeader title="Vaccines Settings">
        {activeTab === "system" && (
          <Button variant="primary" onClick={handleAddVaccine} endIcon={Plus}>
            Add Vaccine
          </Button>
        )}
      </PageHeader>

      <TabSwitcher
        options={TAB_OPTIONS}
        value={activeTab}
        onChange={setActiveTab}
        fullWidth
      />

      {activeTab === "system" && (
        <DataTable
          columns={vaccinesColumns}
          data={vaccines}
          isLoading={isLoadingVaccines}
          emptyTitle="No vaccines found"
          emptyText="No vaccines have been added yet."
          rowsPerPage={20}
          rowActions={rowActions}
          search={{
            value: systemFilters.search.value,
            onChange: systemFilters.search.onChange,
            placeholder: "Search by name or manufacturer",
          }}
          filtersConfig={systemFilters.filtersConfig}
          filters={systemFilters.filters}
        />
      )}

      {activeTab === "healthlink" && (
        <DataTable
          columns={vaccineCodesColumns}
          data={vaccineCodes}
          isLoading={isLoadingCodes}
          emptyTitle="No Healthlink vaccine codes found"
          emptyText="No Healthlink vaccine codes are available."
          rowsPerPage={20}
          search={{
            value: healthlinkFilters.search.value,
            onChange: healthlinkFilters.search.onChange,
            placeholder: "Search by name, sale name or code",
          }}
          filtersConfig={healthlinkFilters.filtersConfig}
          filters={healthlinkFilters.filters}
        />
      )}

      <VaccineModal
        show={showModal}
        onHide={() => setShowModal(false)}
        vaccine={selectedVaccine}
        onSave={handleSaveVaccine}
      />

      <ConfirmDialog
        isOpen={confirmDialog.isOpen}
        onClose={closeConfirmDialog}
        onConfirm={confirmDialog.onConfirm}
        isLoading={isDeleting || isToggling}
        title={confirmDialog.title}
        message={confirmDialog.message}
        confirmLabel={confirmDialog.confirmLabel}
        confirmVariant={confirmDialog.confirmVariant}
      />
    </div>
  );
};
